import { iubendaConfig } from '@/helpers/iubenda';
import { defineStore } from 'pinia';

export const useIubendaStore = defineStore('iubenda', () => {
    const dataPrivacy = ref();
    const cookiePolicy = ref();

    const fetchIubendaData = async () => {
        try {
            const locale = useNuxtApp().$i18n.locale as unknown as { value: string };
            const iubendaBaseUrl = 'https://www.iubenda.com/api/privacy-policy/';
            const iubendaId = iubendaConfig[locale.value].id;

            const privacyData: { success: boolean, content: string } = await $fetch(`${iubendaBaseUrl}${iubendaId}/no-markup`, {
                method: 'get',
            });

            if (privacyData.success === true) {
                dataPrivacy.value = privacyData.content;
            }

            const cookiesData: { success: boolean, content: string } = await $fetch(`${iubendaBaseUrl}${iubendaId}/cookie-policy/no-markup`, {
                method: 'get',
            });

            if (cookiesData.success === true) {
                cookiePolicy.value = cookiesData.content;
            }

        } catch (errorResponse) {
            console.error('ERROR', errorResponse)
        }
    }

    return {
        dataPrivacy,
        cookiePolicy,
        fetchIubendaData
    };
});

export default useIubendaStore;